module.exports = __webpack_public_path__ + "static/media/Employee-database.6312708c.png";